// HeaderTitle.js
import React from 'react';
import styles from './HeaderTitle.module.css'; // Import the CSS module


const HeaderTitle = ({ title, dir }) => {
  const isRTL = dir === 'rtl';

  return (
    <div className={`${styles.first}`} style={{
      marginLeft: isRTL ? "0" : "12px",
      marginRight: isRTL ? "12px" : "0",
      textAlign: isRTL ? 'right' : 'left',
    }}>
      <div className={`${styles.second}`}>
        {title}
      </div>
      <span className={`${styles.third}`} style={{
        left: isRTL ? 'auto' : '0',
        right: isRTL ? '0' : 'auto',
      }}></span>
      <span className={`${styles.four}`} style={{
        left: isRTL ? '0' : 'auto',
        right: isRTL ? 'auto' : '0',
      }}></span>
    </div>
  );
}

export default HeaderTitle;
